<template>
  
    <!-- <h1>Visual Dance</h1> -->
    <div id="nav" class="demo">
      
      <!-- <span><router-link to="/">Home</router-link></span>
        <span><router-link to="/bar_chart_race">Bar chart race</router-link></span>
        <span><router-link to="/sunburst">Sunburst</router-link></span>
        <span><router-link to="/map">Map</router-link></span>
        <span><router-link to="/cloud">Cloud</router-link></span>
        <span><router-link to="/reponsive">Responsive</router-link></span>
        <span><router-link to="/.f">Home</router-link></span>
        <span><router-link to="/about.d">About</router-link></span>
        <span><router-link to="/about">About</router-link></span> -->

      <b-avatar v-b-toggle.sidebar-no-header src="LOGO.png" size="large" class="position"></b-avatar>
      <b-sidebar
        id="sidebar-no-header"
        aria-labelledby="sidebar-no-header-title"
        no-header
        bg-variant="dark"
        shadow
      >
        <template #default="{ hide }">
          <div class="p-3">
            <h4 id="sidebar-no-header-title" style="color:#e50815;font-size:40px">Netflix</h4>
            <p>
              
            </p>
            <nav class="mb-3">
              <b-nav vertical>
                <!-- <b-nav-item active @click="hide">Active</b-nav-item> -->
                <b-nav-item to="/" @click="hide">Home</b-nav-item>
                <b-nav-item to="/line_chart" @click="hide">Leading Content</b-nav-item>
                <b-nav-item to="/responsive" @click="hide">Producing VS User</b-nav-item>
                <b-nav-item to="/map" @click="hide">Country Variation</b-nav-item>
                <b-nav-item to="/bar_chart_race" @click="hide">Ranking Variation</b-nav-item>
                <b-nav-item to="/sunburst" @click="hide">Rating Distribution</b-nav-item>
                <b-nav-item to="/cloud" @click="hide">Common Features</b-nav-item>
                <b-nav-item to="/mapbox" @click="hide">Popular List</b-nav-item>
                <b-nav-item to="/about" @click="hide">About Us</b-nav-item>
              </b-nav>
            </nav>
            <b-button  block @click="hide"
              >Close Sidebar</b-button
            >
          </div>
        </template>
      </b-sidebar>
    </div>
  
</template>

<script>
export default {
  name: "Header",
};
</script>

<style scoped>
.header {
  background: #000;
  /* color: #fff; */
  /* text-align: center; */
  /* display: flex; */

  /* justify-content: space-evenly; */
  padding: 10px; 
}
.position
{
  position: absolute;
  top: 1%;
  left: 1%;
}
.bg-yellow
{
  background-color: #121212;
}
.even {
  /* flex: 1 1 auto; */
}
.header a {
  /* color: #fff;
  padding-right: 5px;
  text-decoration: none; */
}

div.demo {
  /* display:table;
    width:100%; */
  /* margin-left: 0; */
  
  
}
div.demo span {
  /* display: table-cell;
  text-align: center; */
}
</style>